import { __assign } from "tslib";
import toFormUrlEncoded from './to-form-url-encoded';
var JSON_CONTENT_TYPE_REGEXP = /application\/(\w+\+)?json/;
var FORM_URLENCODED_CONTENT_TYPE_REGEXP = /application\/x-www-form-urlencoded/;
var PayloadTransformer = (function () {
    function PayloadTransformer() {
    }
    PayloadTransformer.prototype.toRequestBody = function (options) {
        var contentType = options.headers ? this._getHeader(options.headers, 'Content-Type') : '';
        if (options.body) {
            if (JSON_CONTENT_TYPE_REGEXP.test(contentType)) {
                return JSON.stringify(options.body);
            }
            if (FORM_URLENCODED_CONTENT_TYPE_REGEXP.test(contentType)) {
                return toFormUrlEncoded(options.body);
            }
        }
        return options.body;
    };
    PayloadTransformer.prototype.toResponse = function (xhr) {
        var headers = this._parseResponseHeaders(xhr.getAllResponseHeaders());
        var body = this._parseResponseBody('response' in xhr ? xhr.response : xhr.responseText, headers);
        return {
            body: body,
            headers: headers,
            status: xhr.status,
            statusText: xhr.statusText,
        };
    };
    PayloadTransformer.prototype._parseResponseBody = function (body, headers) {
        var contentType = this._getHeader(headers, 'Content-Type');
        if (body && JSON_CONTENT_TYPE_REGEXP.test(contentType)) {
            return JSON.parse(body);
        }
        return body;
    };
    PayloadTransformer.prototype._parseResponseHeaders = function (rawHeaders) {
        var lines = rawHeaders ? rawHeaders.replace(/\r?\n[\t ]+/g, ' ').split(/\r?\n/) : [];
        return lines.reduce(function (headers, line) {
            var _a;
            var parts = line.split(':');
            var key = (parts.shift() || '').trim();
            if (!key) {
                return headers;
            }
            return __assign(__assign({}, headers), (_a = {}, _a[key.toLowerCase()] = parts.join(':').trim(), _a));
        }, {});
    };
    PayloadTransformer.prototype._getHeader = function (headers, key) {
        if (!headers || !key) {
            return '';
        }
        return headers[key] || headers[key.toLowerCase()] || '';
    };
    return PayloadTransformer;
}());
export default PayloadTransformer;
